


















































































import Vue from "vue";
import Component from "vue-class-component";
import func from "@/ts/FormFunctions";
import { IVueStateCollection } from "@/ts/FormBuilder";
import ErrorMessages from "@/ts/constants/ReportingErrorMessages";
import { ITransferStationVueModel } from "@/ts/models/ITransferStationVueModel";

@Component({
    props: {
        form: {
            type: Object as () => ITransferStationVueModel
        },
        vueStates: {
            type: Object as () => IVueStateCollection
        },
        isReadOnly: {
            type: Boolean
        }
    }
})
export default class TransferStationMaterials extends Vue {
    name: string = "TransferStationMaterials";
    title: string = "";

    errorMsgs = ErrorMessages;

    mounted() {
        this.title = this.$props.vueStates.views[1].name;

        this.$emit("update:title", this.title);
        this.$emit("update:currentIndex", 1);

        this.$watch("hasErrors", (n, o) => {
            this.$props.vueStates.views[1].error = this.hasErrors;
        }, { immediate: true });

        this.$watch("materialWeightFee", (n, o) => {
            this.$props.form.fees[0].amount = n;
        }, { immediate: true });

        this.$props.vueStates.views[1].visited = true;
    }

    get materialWeightTransferred(): number {
        let value: number = 0;
        if (!this.hasErrors) {
            value = (this.$props.form.materialWeightReceived * 1) - (this.$props.form.materialWeightRemoved * 1);
        } 
        
        return value;
    }

    get materialWeightFee(): number {
        let value: number = 0;
        if (!this.hasErrors) {
            value = this.materialWeightTransferred * 0.22;
        } 

        return value;
    }
    /*
    get isReceivedError(): boolean {
        return func.isNullOrEmptyOrZero(this.$props.form.materialWeightReceived) || this.$props.form.materialWeightReceived <= 0;
    }
    
    get isRemovedError(): boolean {
        if (!func.isNullOrEmpty(this.$props.form.materialWeightRemoved)) {
            return (this.$props.form.materialWeightReceived * 1) < (this.$props.form.materialWeightRemoved * 1);
        }
        return false;
    }
    */
    get hasErrors(): boolean {
        return false;
        //return this.isReceivedError || this.isRemovedError;
    }
    
}
